import { ContentViewStyle } from '@levelapp/softfabric';

export default class StatsViewStyle extends ContentViewStyle {     
}